import { useAuthContext } from '../../../../state/useAuth'
import { ROUTES } from '../../../../constants/routes'

export const useLogout = () => {
  const { logout } = useAuthContext()

  return async () => {
    await logout(ROUTES.LANDING_PAGE)
  }
}
